import NavigationBar from "../../General/NavigationBar/NavigationBar";
import TicketsSidebar from "../TicketsSidebar/TicketsSidebar";

const TicketsLayout = ({ children }: { children: React.ReactNode }) => (
  <NavigationBar sidebar={<TicketsSidebar />}>{children}</NavigationBar>
);

export default TicketsLayout;
